<template>
  <div id="pano" style="width: 100%; height: 100%">
  <!-- <div id="pano" style="width: 100%; height: 100%" @click="giveThumbsUpView"> -->
<!--    <div id="pano" style="width: 100%; height: 100%" @click="">-->
    <noscript>
      <table style="width: 100%; height: 100%">
        <tr style="vertical-align: middle">
          <td>
            <div style="text-align: center">
              ERROR:<br /><br />Javascript not activated<br /><br />
            </div>
          </td>
        </tr>
      </table>
    </noscript>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'; 
import { giveThumbsUp, cityInfo, gzwInfo } from "@/utils/tools.js"
import { getThumbsInfo } from "@/api/message.js"
export default {
  data() {
    return {
      krpano: ""
    };
  },

 mounted() {
    var that = this
    embedpano({
      swf: "./vtour/tour.swf",
      xml: "./vtour/tour.xml",
      target: "pano",
      html5: "auto",
      mobilescale: 1.0,
      passQueryParameters: true,
      wmode: "opaque",
      onready: that.krpano_onready_callback,
    });
   

  },
  methods: {
    krpano_onready_callback(krpano_interface) {
      this.krpano = krpano_interface;
      this.$emit("krpanoReady", this.krpano)
    },
    giveThumbsUpView() {
      debugger
      let scene_name = this.krpano.get("xml.scene");
      let zone = scene_name.split("_")[1];
      let sceneShortName = scene_name.split("_")[1] + "_" + scene_name.split("_")[2]
      if("1" == zone){//央企展区投票
        let activeEnterprise = gzwInfo.filter(item => item.sceneName == sceneShortName)[0]
        giveThumbsUp(16020, activeEnterprise.groupId, activeEnterprise.id)
      }else if ("2" == zone){//地方展区投票
        let activeCity = cityInfo.filter(item => item.sceneName == sceneShortName)[0]
        giveThumbsUp(16020, activeCity.groupId, activeCity.id)
      }else {//序厅为央企展区随机投票
        const random = (min, max) => Math.floor(Math.random() * (max - min) + min); //随机数方法
        let index = random(0, gzwInfo.length); //生成一个从最小值为0 最大值为数组长度的随机数
        giveThumbsUp(16020, gzwInfo[index].groupId, gzwInfo[index].id)//随机给央企展区投票
      }

    }
  },
  created() { },
};
</script>

<style lang="scss" scoped>

</style>